import { Observable } from 'rxjs';
import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ENVIRONMENT_CONFIG, EnvironmentConfig } from '@ipreo/northstar';
import { CasaSettings } from '../types/casa-settings.types';

@Injectable()
export class CasaSettingsService {
  private apiHost: string;

  constructor(
    private http: HttpClient,
    @Inject(ENVIRONMENT_CONFIG) environmentConfig: EnvironmentConfig
  ) {
    this.apiHost = environmentConfig.params.apiHost as string;
  }
  public getSettings(): Observable<CasaSettings> {
    return this.http.get<CasaSettings>(`${this.apiHost}/api/v1/settings`);
  }
}
